import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (navigator.userAgent.indexOf("Trident/7.0") !== -1 ||
  window.navigator.userAgent.indexOf("Edge") !== -1) {
  // browser unsupported
} else {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
}
